import { DepartmentsFilter } from '../models';
import { useGetDepartmentsQuery } from '../services';

interface UseDepartmentsProps {
  filters?: DepartmentsFilter;
  paginated: {
    page: number;
    pageSize: number;
  };
}

const useDepartments = ({ filters, paginated }: UseDepartmentsProps) => {
  const {
    data: departments,
    isLoading: isDepartmentsLoading,
    error,
  } = useGetDepartmentsQuery({ filters, paginated });

  return {
    departments: departments?.items || [],
    totalItems: departments?.count || [].length,
    totalPages: departments?.count
      ? Math.ceil(departments.count / paginated.pageSize)
      : 0,
    isDepartmentsLoading,
    error,
  };
};

export default useDepartments;
